import { Injectable } from "@angular/core";
import { LeaApiService } from "./lea-api.service";
import { Beacon } from "app/__models/Beacon";

@Injectable()
export class StolenVehiclesService {
  constructor(private _rest: LeaApiService) {}

  public getTheftReports() {
    let uri: string = "/admin/beacons/reports";
    return this._rest.get(uri);
  }

  public getTheftReportsSynthesis() {
    let uri: string = "/admin/beacons/synthesis/reports";
    return this._rest.get(uri);
  }

  public getTheftReport(reportId: string) {
    let uri: string = `/admin/beacons/reports/${reportId}`;
    return this._rest.get(uri);
  }

  public createTheftReport(
    beacon: string,
    major: number,
    minor: number,
    theftReportDate: Date,
  ) {
    let uri: string = "/admin/beacons/report";
    let payload = {
      uuid: beacon,
      major: major,
      minor: minor,
      theftReportDate: theftReportDate.toISOString(),
    };
    return this._rest.postByCustomer(uri, payload);
  }

  public cancelTheftReport(reportId: string) {
    let uri: string = `/admin/beacons/reports/${reportId}`;
    return this._rest.deleteByCustomer(uri);
  }

  public closeTheftReport(reportId: string, reason: string, comment: string) {
    let uri: string = `/admin/beacons/reports/${reportId}/close`;
    let payload = {
      reason: reason,
      comment: comment,
    };
    return this._rest.putByCustomer(uri, payload);
  }

  public getBeaconLocations(beacon: Beacon) {
    let uri: string = `/admin/beacons/locations?uuid=${beacon.uuid}&major=${beacon.major}&minor=${beacon.minor}`;
    return this._rest.getByCustomer(uri);
  }
}
